import React from 'react';
import { useAppSelector } from '../../hooks/storeHooks';
import {
  scanMultipleWells,
  startAssets,
  shutdownAssets,
  clearAlarmsAssets,
  resetClocksAssets,
} from '../../services/wellControlService';

const useWellControlActions = (
  selectedAssetIds: string[],
  onScanComplete?: (success: boolean, message?: string) => void,
) => {
  const [isLoading, setIsLoading] = React.useState(false);
  const socketId = useAppSelector((state: any) => state.assetGroups?.socketId) ?? '';

  const handleScanAction = async () => {
    // if (!socketId) {
    //   throw new Error('Socket connection not available');
    // }
    setIsLoading(true);
    try {
      const result = await scanMultipleWells(selectedAssetIds, socketId);
      if (result.success) {
        const message = result.message || `Scan request sent for ${selectedAssetIds.length} well(s)`;
        onScanComplete?.(true, result.message);
        return { success: true, message };
      } else {
        const error = result.error || 'Failed to scan wells';
        onScanComplete?.(false, result.error);
        throw {
          message: error,
          errorDetails: result.errorDetails,
        };
      }
    } catch (error: any) {
      const errorMsg = error.message || 'An unexpected error occurred while scanning wells';
      onScanComplete?.(false, errorMsg);
      throw error; // Pass the complete error object, including errorDetails if present
    } finally {
      setIsLoading(false);
    }
  };

  const executeAction = async (actionCommand: string): Promise<any> => {
    // if (!socketId) {
    //   throw new Error('Socket connection not available');
    // }

    let result;
    switch (actionCommand) {
      case 'Scan':
        return handleScanAction();
      case 'Start Asset':
        result = await startAssets(selectedAssetIds, socketId);
        break;
      case 'Shutdown Asset':
        result = await shutdownAssets(selectedAssetIds, socketId);
        break;
      case 'Clear Alarms':
        result = await clearAlarmsAssets(selectedAssetIds, socketId);
        break;
      case 'Reset clocks':
        result = await resetClocksAssets(selectedAssetIds, socketId);
        break;
      default:
        // For actions not yet implemented, return a mock success
        return Promise.resolve({
          success: true,
          message: `${actionCommand} command sent successfully`,
        });
    }

    if (result.success) {
      return result;
    } else {
      throw {
        message: result.error,
        errorDetails: result.errorDetails,
      };
    }
  };

  return {
    isLoading,
    executeAction,
  };
};

export default useWellControlActions;
